<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<div fxFlex="row">
    <div fxFlex="240px" class="sidenavigationTop hidexs">
       
        <div class="iwg-service-name" *ngIf="ShowEOREstimator || !EORDisabled">Employer of Record</div>
        <div class="sidenavigationInner" style="padding-bottom:0;">
        <div *ngIf="ShowEOREstimator">
            <a href="javascript:void(0);" class="custom-sidemenu active-side-nav" layout
            [routerLink]="['/quoteEstimator/7b57522b-d0d6-403c-b524-1f0e2f24003c']" [queryParams]="{service: 1, global_scope: 2}">
            Estimator
            <span  [ngClass]="{'textSuccess':activeiconcolor==''}" class="sidemenuactiveiconcolor"></span></a>
        </div>
        <div *ngIf="ShowEORQuotes && !EORDisabled">
            <a href="javascript:void(0);" class="custom-sidemenu" layout
            [routerLink]="['/quotes']" [queryParams] = "{
                service: 1}" >
            Quotes<span flex></span>
            <span flex></span></a>
        </div>
        <div *ngIf="!EORDisabled">
            <a href="javascript:void(0);" class="custom-sidemenu" layout
            [routerLink]="['/assignments']" [queryParams] = "{
                service: 1}" >
            Assignments<span flex></span>
            <span flex></span></a>
        </div>
        </div>

        <div class="iwg-service-name" *ngIf="!ComplianceDisabled">Compliance</div>
        <div class="sidenavigationInner" style="padding-bottom:0;" *ngIf="!ComplianceDisabled">
            <div *ngIf="ShowComplianceQuotes">
                <a href="javascript:void(0);" class="custom-sidemenu" layout
                [routerLink]="['/quotes']" [queryParams] = "{
                    service: 3}" >
                Quotes<span flex></span>
                <span flex></span></a>
            </div>
            <div>
                <a  href="javascript:void(0);" class="custom-sidemenu" layout
                [routerLink]="['/assignments']" [queryParams] = "{
                    service: 3}" >
                Evaluations<span flex></span>
                <span flex></span></a>
            </div>
        </div>

        <div class="iwg-service-name" *ngIf="!AORDisabled">Agent of Record</div>
        <div class="sidenavigationInner" style="padding-bottom:0;" *ngIf="!AORDisabled">
            <div *ngIf="ShowAORQuotes">
                <a href="javascript:void(0);" class="custom-sidemenu" layout
                [routerLink]="['/quotes']" [queryParams] = "{
                    service: 2}" >
                Quotes<span flex></span>
                <span flex></span></a>
            </div>
            <div>
                <a href="javascript:void(0);" class="custom-sidemenu" layout
                [routerLink]="['/assignments']" [queryParams] = "{
                    service: 2}" >
                Engagements<span flex></span>
                <span flex></span></a>
            </div>
        </div>
        <div class="sidenavigationInner">
            <app-buttonbar></app-buttonbar>
        </div>
</div>

<div fxFlex.gt-sm="calc(100% - 240px)"  [ngStyle.lt-md]="{'flex': 1}">
        <div  class="content">
            <div class="iwg-page-header-breadcrumb">
                <span>Services</span> » <span>{{selectedServiceName}}</span> » <span
                    class="iwg-page-header-small-title">EOR Estimator</span>
            </div>
            <mat-divider></mat-divider>
            <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between">
                <div class="vista-quotepage">
                    <form class="iwg-widget-box iwg-quote-workers-details-boxNOT quote-estimator-form" name="quoteEstimatorForm" #quoteEstimatorForm="ngForm" novalidate>
                        <h3>EOR Estimator</h3>
                        <div class="md-input-container mb10 estimator-select">
                                <app-country-select name="worker_scountry"
                                    name="country"
                                    [(ngModel)]="FormData.selectedCountry"
                                    [preselectedItemId]="null"
                                    [isRequired]="true"
                                    [alltext]="'Please Select'"
                                    [idOnly]="false"
                                    [customcss]="true"
                                    helptext = "Select the country in which the work will be performed."
                                    [activeonly]="true"
                                    (countryChange)="updateCountry($event)"
                                    [labeltext]="'Country'">
                                </app-country-select>
                        </div>
                        <div class="md-input-container mb10">
                            <mat-form-field class="mat-form-withtooltip" style="width: 90%;">
                                <mat-label>Pay Amount</mat-label>
                                <input matInput #payrate="ngModel" [(ngModel)]="FormData.pay_rate"
                                    name="pay_rate" type="number" required
                                    min="0.01">
                            </mat-form-field>
                            <mat-icon
                                matTooltip="How much do you expect to pay the worker(s)?"
                                matTooltipPosition="above" class="md-iwgNavbar-theme material-icons">help
                            </mat-icon>
                            <mat-error *ngIf="!payrate.valid && payrate.touched">Required</mat-error>
                        </div>
                        <div class="mb10">
                            <app-currency-select 
                            name="countryselect"
                            [(ngModel)]="FormData.selectedCurrency"
                            [preselected-item-id]="FormData.selectedCountry?.ID"
                            [selected-country-id]="FormData.selectedCountry?.ID"
                            [helptext]="'Select the currency in which the worker(s) will be paid.'"
                            [label]="'Pay Currency'"
                            [required]="true"
                            [add-united-states]="false"
                            ></app-currency-select>
                        </div>
                        <div class="mb10 estimator-payrate">
                            <app-pay-rate-select 
                            name="prate"
                            [(ngModel)]="FormData.selectedPayRateType"
                            [preselected-item-id]="selectedPayRateType?.ID"
                            [helptext]="'Select the frequency at which the worker(s) will be paid.'"
                            [label]="'Pay Rate'"
                            [required]="true"
                            ></app-pay-rate-select>
                        </div>
                        <div class="md-input-container mb10" *ngIf="FormData.selectedPayRateType?.Name=='Hour'">
                            <mat-form-field class="mat-form-withtooltip" style="width: 90%">
                                <mat-label>Typical Weekly Hours</mat-label>
                                <input matInput #weekhourse [(ngModel)]="FormData.weekly_hours" 
                                    name="weekly_hours" type="number" required
                                    min="0.01">
                            </mat-form-field>
                            <mat-icon
                                matTooltip="Please specify the average number of hours each week the worker will provide services to your company."
                                matTooltipPosition="above" class="md-iwgNavbar-theme material-icons">help
                            </mat-icon>
                            <mat-error *ngIf="!weekhourse.valid && weekhourse.touched">Required</mat-error>
                        </div>


                        <div fxLayoutAlign="center center">
                        <button (click)="submit()" [disabled]="!canProceed()" mat-button class="mat-buttoncolor">Calculate Estimate</button>

                    </div>
                    

                    </form>

                </div>
                <div class="iwg-space"></div>
                <div class="two flex">
                    <div class="iwg-widget-box" *ngIf="ShowErrorPanel" style="padding: 0">
                        <div class="iwg-widget-box-header">
                            Unable to Estimate
                            <div class="iwg-widget-box-body">
                                <ul>
                                    <li>Quote estimates are not available for this country.</li>
                                    <li>Please request a quote by clicking on "Get A Quote".</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="iwg-widget-box" *ngIf="ShowIncommpleteErrorPanel" style="padding: 0">
                        <div class="iwg-widget-box-header">
                            Unable to Estimate
                            <div class="iwg-widget-box-body">
                                <ul>
                                    <li>Please complete all required fields and then click "Calculate Estimate".</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="iwg-widget-box" style="width: 200px;" *ngIf="ShowCalculatingPanel">
                        <div class="iwg-widget-box-header" style="border-bottom: none;">
                            Calculating Estimate...
                        </div>
                    </div>
                    
                    <div flex *ngIf="ShowQuoteEstimate">
                        <div class="hide-on-sm">
                        <table width="100%">
                            <tr width="100%">
                                <td>
                                    <div class="iwg-widget-box" style="padding: 0">
                                        <div class="iwg-widget-box-header">Estimate</div>
                                        <div class="iwg-widget-box-body content-md" styleNOT="font-size:16px;font-family:Lato,Helvetica Neue,sans-serif;color: rgba(0,0,0,.77);">
                                            <span style="padding-left:10px;"><b>This is only an Estimate based on limited information.</b></span><br />
                                            <span style="padding-left:10px;"><b>A Quote is required prior to engaging a worker.</b></span><br />
                                            <span style="padding-left:10px;"><b>To get a Quote for a specific assignment, please click "Get A Quote".</b></span><br />
                                        </div>
                                    </div>
                                </td>
                                <td width="10px">&nbsp;</td>
                                <td width="300px" valign="top">
                                    <div class="iwg-widget-box-quote-header-image"
                                        [ngStyle]="{'background-image': countryGuide?.Country?'url(' + countryGuide?.Country.ImageURL + ')':''}">
                                    </div>
                                </td>
                            </tr>
                        </table>
                        </div>
                        <div class="show-on-sm">
                            <div class="iwg-widget-box" style="padding: 0">
                                <div class="iwg-widget-box-header">Estimate</div>
                                <div class="iwg-widget-box-body content-md" styleNOT="font-size:16px;font-family:Lato,Helvetica Neue,sans-serif;color: rgba(0,0,0,.77);">
                                    <span style="padding-left:10px;"><b>This is only an Estimate based on limited information.</b></span><br />
                                    <span style="padding-left:10px;"><b>A Quote is required prior to engaging a worker.</b></span><br />
                                    <span style="padding-left:10px;"><b>To get a Quote for a specific assignment, please click "Get A Quote".</b></span><br />
                                </div>
                            </div>

                            <div class="iwg-widget-box-quote-header-image"
                                        [ngStyle]="{'background-image': countryGuide?.Country?'url(' + countryGuide?.Country.ImageURL + ')':''}">
                                    </div>
                        </div>

                        <div class="iwg-space"></div>

                        <div flex class="mat-table-container">
                            <div class="iwg-widget-box-header">
                                {{quote.QuoteRequest_Service_Name}}
                            </div>
                            <div class="table-resp-scroll hide-on-sm">
                            <table md-table flex class="ptable" style="width: 100%">
                                <thead md-head>
                                    <tr md-row>
                                        <th md-column><span>Pay Rate ({{quote.QuoteRequest_PayCurrency_Abbreviation}})</span></th>
                                        <th md-column><span>Employer Burden (%)</span></th>
                                        <th md-column><span>Deposit (Months)</span></th>
                                        <th md-column><span>Setup Fee ({{EntityCurrencyCode}})</span></th>
                                        <th md-column><span>Monthly Management Fee ({{EntityCurrencyCode}})</span></th>
                                        
                                        <th md-column><span>{{quote.SalesTaxLabel}} (%)</span></th>
                                    </tr>
                                </thead>
                                <tbody md-body>
                                    <tr md-row>
                                        <td md-cell>{{quote.QuotePricing_LocalAnnualPay | currency: quote.QuoteRequest_PayCurrency_Abbreviation:(quote.QuoteRequest_PayCurrency_Symbol || '') :  '1.2-2'}} ({{quote.QuoteRequest_PayCurrency_Abbreviation}})</td>
                                        <td md-cell>{{(quote.QuotePricing_EmployerBurdenPercent/100) | percent : '1.2-2' | blank}}</td>
                                        <td md-cell>{{quote.QuotePricing_DepositMonths  | blank}}</td>
                                        <td md-cell>{{quote.QuotePricing_SetupFee | currency : '':'$' : '1.2-2' | blank}} ({{EntityCurrencyCode}})</td>

                                        <td md-cell *ngIf="IsPartnerQuoteFormat && quote.QuotePricing_IsPricingMarkupBased==1">${{quote.QuotePricing_CalculatedMarkupAmountUSD | number:'.2' }} ({{EntityCurrencyCode}}) <br />= {{(quote.QuotePricing_CalculatedMarkup/100) | percent : '1.2-2' | blank}} Markup</td>
                                        <td md-cell *ngIf="IsPartnerQuoteFormat && quote.QuotePricing_IsPricingMarkupBased==0">${{quote.QuotePricing_CalculatedMarkupAmountUSD | number:'.2' }} ({{EntityCurrencyCode}})</td>
                                        <td md-cell *ngIf="!IsPartnerQuoteFormat">{{(quote.QuotePricing_CalculatedMarkup/100) | percent : '1.2-2' | blank}} Markup</td>

                                       
                                        <td md-cell>{{(quote.QuotePricing_Vat/100) | percent : '1.2-2' | blank}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                            <div class="show-on-sm">
                                <table class="ptable headerWborder" style="width: 100%">
                                    <tbody>
                                        <tr>
                                            <th><span>Pay Rate ({{quote.QuoteRequest_PayCurrency_Abbreviation}})</span></th>
                                            <td>{{quote.QuotePricing_LocalAnnualPay | currency: quote.QuoteRequest_PayCurrency_Abbreviation:(quote.QuoteRequest_PayCurrency_Symbol || '') :  '1.2-2'}} ({{quote.QuoteRequest_PayCurrency_Abbreviation}})</td>
                                        </tr>
                                        <tr>
                                            <th>Employer Burden (%)</th>
                                            <td>{{(quote.QuotePricing_EmployerBurdenPercent/100) | percent : '1.2-2' | blank}}</td>
                                        </tr>
                                        <tr>
                                            <th>Deposit (Months)</th>
                                            <td>{{quote.QuotePricing_DepositMonths  | blank}}</td>
                                        </tr>
                                        <tr>
                                            <th>Setup Fee ({{EntityCurrencyCode}})</th>
                                            <td>{{quote.QuotePricing_SetupFee | currency : '':'$' : '1.2-2' | blank}} ({{EntityCurrencyCode}})</td>
                                        </tr>
                                        <tr>
                                            <th>Monthly Management Fee ({{EntityCurrencyCode}})</th>
                                            <td *ngIf="IsPartnerQuoteFormat && quote.QuotePricing_IsPricingMarkupBased==1">${{quote.QuotePricing_CalculatedMarkupAmountUSD | number:'.2' }} ({{EntityCurrencyCode}}) <br />= {{(quote.QuotePricing_CalculatedMarkup/100) | percent : '1.2-2' | blank}} Markup</td>
                                            <td *ngIf="IsPartnerQuoteFormat && quote.QuotePricing_IsPricingMarkupBased==0">${{quote.QuotePricing_CalculatedMarkupAmountUSD | number:'.2' }} ({{EntityCurrencyCode}})</td>
                                            <td *ngIf="!IsPartnerQuoteFormat">{{(quote.QuotePricing_CalculatedMarkup/100) | percent : '1.2-2' | blank}} Markup</td>
                                        </tr>
                                        <tr>
                                            <th>{{quote.SalesTaxLabel}} (%)</th>
                                            <td>{{(quote.QuotePricing_Vat/100) | percent : '1.2-2' | blank}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <br />
                            <table  class="ptable" md-table flex *ngIf="quote.QuoteRequest_Country_Abbreviation == 'US' && (quote.QuoteRequest_Service_ServiceTypeEnumID ==1 || quote.QuoteRequest_Service_ServiceTypeEnumID ==2)">
                                <thead md-head>
                                    <tr md-row>
                                        <th md-column><span>Markup (%)</span></th>
                                    </tr>
                                </thead>
                                <tbody md-body>
                                    <tr md-row>
                                        <td md-cell>{{(quote.QuotePricing_Markup/100) | percent : '1.2-2' | blank}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table  class="ptable" md-table flex *ngIf="quote.QuoteRequest_Service_ServiceTypeEnumID ==3">
                                <thead md-head>
                                    <tr md-row>
                                        <th md-column><span>Evaluation Cost</span></th>
                                        <th md-column><span>{{quote.SalesTaxLabel}} (%)</span></th>
                                    </tr>
                                </thead>
                                <tbody md-body>
                                    <tr md-row>
                                        <td md-cell>${{quote.QuotePricing_MinimumFee}} {{EntityCurrencyCode}}</td>
                                        <td md-cell>{{(quote.QuotePricing_Vat/100) | percent : '1.2-2' | blank}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="iwg-space"></div>

                        <div flex="auto" class="mat-table-container">
                            <div class="iwg-widget-box-header">
                                Sample Invoice
                            </div>
                            <div class="table-resp-scroll">
                            <table  class="ptable epad" md-table flex  style="width: 100%">
                                <thead md-head>
                                    <tr md-row>
                                        <th md-column><span><label class="iwg-label">Item</label></span></th>

                                        <th md-column><span><label class="iwg-label">Amount ({{quote.QuoteRequest_PayCurrency_Abbreviation}})</label></span></th>
                                        <th md-column *ngIf="quote.QuoteRequest_PayCurrency_Abbreviation !=EntityCurrencyCode"><span><label class="iwg-label">Amount ({{EntityCurrencyCode}})</label></span></th>

                                        <th md-column class="hide-on-sm"><span><label class="iwg-label">Details</label></span></th>
                                    </tr>
                                </thead>
                                <tbody md-body>
                                    <tr md-row>
                                        <td md-cell *ngIf="quote.QuoteRequest_Service_ServiceTypeEnumID ==1">Annual Salary</td>
                                        <td md-cell *ngIf="quote.QuoteRequest_Service_ServiceTypeEnumID ==2 || quote.QuoteRequest_Service_ServiceTypeEnumID ==3">Annual Contractor Bill</td>

                                        <td md-cell>{{quote.QuotePricing_LocalAnnualPay | currency:quote.QuoteRequest_PayCurrency_Abbreviation:(quote.QuoteRequest_PayCurrency_Symbol || '') : '1.2-2'}}</td>
                                        <td md-cell *ngIf="quote.QuoteRequest_PayCurrency_Abbreviation != EntityCurrencyCode">{{quote.QuotePricing_AnnualPayUSD | currency :EntityCurrencyCode:'$'  : '1.2-2'}}</td>

                                        <td md-cell  class="hide-on-sm"> {{quote.QuotePricing_PayPeriodsPerYearText}}</td>
                                    </tr>
                                    <tr md-row>
                                        <td md-cell *ngIf="quote.QuoteRequest_Service_ServiceTypeEnumID ==1">Monthly Salary</td>
                                        <td md-cell *ngIf="quote.QuoteRequest_Service_ServiceTypeEnumID ==2 || quote.QuoteRequest_Service_ServiceTypeEnumID ==3">Monthly Contractor Bill</td>

                                        <td md-cell>{{quote.QuotePricing_MonthlySalary | currency:quote.QuoteRequest_PayCurrency_Abbreviation:(quote.QuoteRequest_PayCurrency_Symbol || '') : '1.2-2'}}</td>
                                        <td md-cell *ngIf="quote.QuoteRequest_PayCurrency_Abbreviation != EntityCurrencyCode">{{quote.QuotePricing_MonthlySalaryUSD  | currency :EntityCurrencyCode:'$' : '1.2-2'}}</td>

                                        <td md-cell  class="hide-on-sm" *ngIf="quote.QuoteRequest_Service_ServiceTypeEnumID ==1">= Annual Salary / {{quote.QuotePricing_PaymentsPerYear}}</td>
                                        <td md-cell  class="hide-on-sm" *ngIf="quote.QuoteRequest_Service_ServiceTypeEnumID ==2 || quote.QuoteRequest_Service_ServiceTypeEnumID ==3">= Annual Contractor Bill / 12</td>
                                    </tr>
                                    <tr md-row *ngIf="quote.QuoteRequest_Service_ServiceTypeEnumID ==1 && IsPartnerQuoteFormat==true">

                                        <td md-cell>Employer Burden (%)</td>

                                        <td md-cell>{{(quote.QuotePricing_EmployerBurdenPercent/100) | percent : '1.2-2'}}</td>
                                        <td md-cell *ngIf="quote.QuoteRequest_PayCurrency_Abbreviation != EntityCurrencyCode">{{(quote.QuotePricing_EmployerBurdenPercent/100) | percent : '1.2-2'}}</td>

                                        <td md-cell  class="hide-on-sm"></td>
                                    </tr>
                                    <tr md-row *ngIf="quote.QuoteRequest_Service_ServiceTypeEnumID ==1 && IsPartnerQuoteFormat==true">
                                        <td md-cell>Monthly Burden</td>

                                        <td md-cell>{{quote.QuotePricing_MonthlyBurden | currency:quote.QuoteRequest_PayCurrency_Abbreviation:(quote.QuoteRequest_PayCurrency_Symbol || '') : '1.2-2'}}</td>
                                        <td md-cell *ngIf="quote.QuoteRequest_PayCurrency_Abbreviation !=EntityCurrencyCode">{{quote.QuotePricing_MonthlyBurdenUSD  | currency :EntityCurrencyCode:'$' : '1.2-2'}}</td>

                                        <td md-cell  class="hide-on-sm">= Monthly Salary * Employer Burden %</td>
                                    </tr>
                                    <tr md-row *ngIf="quote.QuoteRequest_Service_ServiceTypeEnumID ==1 && IsPartnerQuoteFormat==true">
                                        <td md-cell>Burdened Salary</td>

                                        <td md-cell>{{quote.QuotePricing_BurdenedSalary | currency:quote.QuoteRequest_PayCurrency_Abbreviation:(quote.QuoteRequest_PayCurrency_Symbol || '') : '1.2-2'}}</td>
                                        <td md-cell *ngIf="quote.QuoteRequest_PayCurrency_Abbreviation != EntityCurrencyCode">{{quote.QuotePricing_BurdenedSalaryUSD | currency :EntityCurrencyCode:'$'  : '1.2-2'}}</td>

                                        <td md-cell  class="hide-on-sm">= Monthly Salary + Monthly Burden</td>
                                    </tr>
                                    <tr md-row *ngIf="quote.QuotePricing_PricingModelID==1">
                                        <td md-cell>Management Fee</td>

                                        <td md-cell>{{quote.QuotePricing_MarkupAmount | currency:quote.QuoteRequest_PayCurrency_Abbreviation:(quote.QuoteRequest_PayCurrency_Symbol || '') : '1.2-2'}}</td>
                                        <td md-cell *ngIf="quote.QuoteRequest_PayCurrency_Abbreviation !=EntityCurrencyCode">{{quote.QuotePricing_CalculatedMarkupAmountUSD  | currency :EntityCurrencyCode:'$'  : '1.2-2'}}</td>

                                        <td md-cell  class="hide-on-sm" *ngIf="quote.QuoteRequest_Service_ServiceTypeEnumID ==1 && IsPartnerQuoteFormat==true && quote.QuotePricing_IsPricingMarkupBased==1">= Burdened Salary * Markup %</td>
                                        <td md-cell  class="hide-on-sm" *ngIf="quote.QuoteRequest_Service_ServiceTypeEnumID ==1 && IsPartnerQuoteFormat==true && quote.QuotePricing_IsPricingMarkupBased==0"></td>
                                       

                                        <td md-cell *ngIf="quote.QuoteRequest_Service_ServiceTypeEnumID ==1 && IsPartnerQuoteFormat!=true">= Salary * Markup %</td>
                                        <td md-cell *ngIf="quote.QuoteRequest_Service_ServiceTypeEnumID ==2 || quote.QuoteRequest_Service_ServiceTypeEnumID ==3">= Monthly Contractor Bill * Markup %</td>
                                    </tr>
                                    <tr md-row *ngIf="quote.QuotePricing_PricingModelID==2">
                                        <td md-cell>Management Fee</td>

                                        <td md-cell>{{quote.QuotePricing_ManagementFeeLocal | currency:quote.QuoteRequest_PayCurrency_Abbreviation:(quote.QuoteRequest_PayCurrency_Symbol || ''):'' : '1.2-2'}}</td>
                                        <td md-cell *ngIf="quote.QuoteRequest_PayCurrency_Abbreviation != EntityCurrencyCode">{{quote.QuotePricing_ManagementFee | currency :EntityCurrencyCode:'$'  : '1.2-2'}}</td>

                                        <td md-cell  class="hide-on-sm">
                                            Monthly Management  Fee
                                        </td>
                                    </tr>
                                    <tr md-row>
                                        <td md-cell>Subtotal</td>

                                        <td md-cell>{{quote.QuotePricing_Subtotal | currency:quote.QuoteRequest_PayCurrency_Abbreviation:(quote.QuoteRequest_PayCurrency_Symbol || '') : '1.2-2'}}</td>
                                        <td md-cell *ngIf="quote.QuoteRequest_PayCurrency_Abbreviation != EntityCurrencyCode">{{quote.QuotePricing_SubtotalUSD | currency :EntityCurrencyCode:'$'  : '1.2-2'}}</td>

                                        <td md-cell  class="hide-on-sm" *ngIf="quote.QuoteRequest_Service_ServiceTypeEnumID ==1 && IsPartnerQuoteFormat==true">= Burdened Salary + Management Fee</td>
                                        <td md-cell  class="hide-on-sm" *ngIf="quote.QuoteRequest_Service_ServiceTypeEnumID ==1 && IsPartnerQuoteFormat!=true">= Salary + Management Fee</td>
                                        <td md-cell  class="hide-on-sm" *ngIf="quote.QuoteRequest_Service_ServiceTypeEnumID ==2 || quote.QuoteRequest_Service_ServiceTypeEnumID ==3">= Monthly Contractor Bill + Management Fee</td>
                                    </tr>
                                    <tr md-row>
                                        <td md-cell>{{quote.SalesTaxLabel}} (%)</td>

                                        <td md-cell>{{(quote.QuotePricing_Vat/100) | percent : '1.2-2'}}</td>
                                        <td md-cell *ngIf="quote.QuoteRequest_PayCurrency_Abbreviation != EntityCurrencyCode">{{(quote.QuotePricing_Vat/100) | percent : '1.2-2'}}</td>

                                        <td md-cell  class="hide-on-sm"></td>
                                    </tr>
                                    <tr md-row>
                                        <td md-cell>{{quote.SalesTaxLabel}} Amount</td>

                                        <td md-cell>{{quote.QuotePricing_VATAmount | currency:quote.QuoteRequest_PayCurrency_Abbreviation:(quote.QuoteRequest_PayCurrency_Symbol || '') : '1.2-2'}}</td>
                                        <td md-cell *ngIf="quote.QuoteRequest_PayCurrency_Abbreviation != EntityCurrencyCode">{{quote.QuotePricing_VATAmountUSD  | currency :EntityCurrencyCode:'$'  : '1.2-2'}}</td>

                                        <td md-cell  class="hide-on-sm">= Subtotal * {{quote.SalesTaxLabel}} %</td>
                                    </tr>
                                    <tr md-row>
                                        <td md-cell>Estimated Monthly Invoice</td>

                                        <td md-cell>{{quote.QuotePricing_EstimatedMonthlyInvoiceLocal | currency:quote.QuoteRequest_PayCurrency_Abbreviation:(quote.QuoteRequest_PayCurrency_Symbol || '') : '1.2-2'}}</td>
                                        <td md-cell *ngIf="quote.QuoteRequest_PayCurrency_Abbreviation != EntityCurrencyCode">{{quote.QuotePricing_EstimatedMonthlyInvoiceUSD | currency :EntityCurrencyCode:'$'  : '1.2-2'}}</td>

                                        <td md-cell  class="hide-on-sm" *ngIf="quote.QuoteRequest_Service_ServiceTypeEnumID ==1 && IsPartnerQuoteFormat==true">
                                            = Burdened Salary + Management Fee + {{quote.SalesTaxLabel}} Amount
                                            <div *ngIf="quote.QuoteRequest_PayCurrency_Abbreviation != EntityCurrencyCode">
                                                Conversion Rate Snapshot on {{quote.QuotePricing_QuoteDate | date}} is: {{1 | currency:quote.QuoteRequest_PayCurrency_Abbreviation:(quote.QuoteRequest_PayCurrency_Symbol || '') : '1.2-2'}} ({{quote.QuoteRequest_PayCurrency_Abbreviation}})= {{quote.QuotePricing_ConversionToUSD | currency :EntityCurrencyCode:'$'  :".6"}} ({{EntityCurrencyCode}})
                                            </div>
                                        </td>
                                        <td md-cell  class="hide-on-sm" *ngIf="quote.QuoteRequest_Service_ServiceTypeEnumID ==1 && IsPartnerQuoteFormat!=true">
                                            = Salary + Management Fee + {{quote.SalesTaxLabel}} Amount
                                            <div *ngIf="quote.QuoteRequest_PayCurrency_Abbreviation != EntityCurrencyCode">
                                                Conversion Rate Snapshot on {{quote.QuotePricing_QuoteDate | date}} is: {{1 | currency:quote.QuoteRequest_PayCurrency_Abbreviation:(quote.QuoteRequest_PayCurrency_Symbol || '') : '1.2-2'}} ({{quote.QuoteRequest_PayCurrency_Abbreviation}})= {{quote.QuotePricing_ConversionToUSD | currency :EntityCurrencyCode:'$'  :".6"}} ({{EntityCurrencyCode}})
                                            </div>
                                        </td>
                                        <td md-cell  class="hide-on-sm" *ngIf="quote.QuoteRequest_Service_ServiceTypeEnumID ==2 || quote.QuoteRequest_Service_ServiceTypeEnumID ==3">
                                            = Monthly Contractor Bill + Management Fee + {{quote.SalesTaxLabel}} Amount
                                            <div *ngIf="quote.QuoteRequest_PayCurrency_Abbreviation != EntityCurrencyCode">
                                                Conversion Rate Snapshot on {{quote.QuotePricing_QuoteDate | date}} is: {{1 | currency:quote.QuoteRequest_PayCurrency_Abbreviation:(quote.QuoteRequest_PayCurrency_Symbol || '') : '1.2-2'}} ({{quote.QuoteRequest_PayCurrency_Abbreviation}})= {{quote.QuotePricing_ConversionToUSD | currency :EntityCurrencyCode:'$'  :"6"}} ({{EntityCurrencyCode}})
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                             </div>
                        </div>

                        <div class="iwg-space"></div>

                        <div class="iwg-widget-box" style="padding: 0;">
                            <div class="iwg-widget-box-header">Notes</div>
                            <div class="iwg-widget-box-body" *ngIf="IsPartnerQuoteFormat">
                                <ol>
                                    <li>Deposit is a one-time, per worker fee.</li>
                                    <li>Setup Fee is a one-time, non-refundable, per worker fee.</li>
                                    <li>Monthly Management Fee is charged per worker, per month.</li>
                                    <li>Expense Markup indicates whether there is a fee for processing expenses when they are processed with pay. {{quote.SalesTaxLabel}} is applied to expenses.</li>
                                    <li>{{quote.SalesTaxLabel}}, if applicable is applied to the full invoiced amount. It applies to pay and Monthly Management Fee.</li>
                                    <li>Estimate is reflective of base salary only. Supplemental compensation e.g. bonuses, commissions, etc. are not included.</li>
                                    <li>Estimate is for 1 local worker.</li>
                                    <li>This is only an Estimate based on limited information.</li>
                                    <li>To get a Quote for a specific assignment, please click "Get A Quote".  A Quote is required prior to engaging a worker.</li>
                                </ol>
                            </div>
                            <div class="iwg-widget-box-body" *ngIf="!IsPartnerQuoteFormat">
                                <ol>
                                    <li>Deposit is a one-time, per worker fee.</li>
                                    <li>Setup Fee is a one-time, non-refundable, per worker fee.</li>
                                    <li>Monthly Management Fee is charged per worker, per month.</li>
                                    <li>Includes Employer Burden of {{(quote.QuotePricing_EmployerBurdenPercent/100) | percent : '1.2-2' | blank}}.</li>
                                    <li>Expense Markup indicates whether there is a fee for processing expenses when they are processed with pay. {{quote.SalesTaxLabel}} is applied to expenses.</li>
                                    <li>{{quote.SalesTaxLabel}}, if applicable is applied to the full invoiced amount. It applies to pay and Monthly Management Fee.</li>
                                    <li>Estimate is reflective of base salary only.Supplemental compensation e.g. bonuses, commissions, statutory holiday pay and vacation pay are not included. Supplemental compensation will be billed with the markup applied.</li>
                                    <li>Estimate is for 1 local worker.</li>
                                    <li>This is only an Estimate based on limited information.</li>
                                    <li>To get a Quote for a specific assignment, please click "Get A Quote".  A Quote is required prior to engaging a worker.</li>
                                </ol>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
         </div>
         <div class="innerpage-footer">
            <app-iwg-footer [blurBg]="true"></app-iwg-footer>
          </div>
    </div>
</div>


